import { render, staticRenderFns } from "./tracking-edit.vue?vue&type=template&id=1f120512"
import script from "./tracking-edit.vue?vue&type=script&lang=js"
export * from "./tracking-edit.vue?vue&type=script&lang=js"
import style0 from "./tracking-edit.vue?vue&type=style&index=0&id=1f120512&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports